export default __webpack_public_path__ + "static/media/IconLink.d02c424a.svg";